import React, {useEffect, useState} from 'react';
import './footer.scss'

const Footer = () => {
	const [FooterData, setFooterData] = useState ([]);
	
	const getAllFooterData = async () => {
		try {
			const response = await fetch ('/data/uielements.json');
			if (!response.ok) {
				throw new Error ('Failed to fetch data');
			}
			const data = await response.json ();
			const filterFooterData = data.UIElements?.filter ((uicode) => uicode.UIElementId === "UIElemetFooter");
			setFooterData (filterFooterData || []);
		} catch (err) {
			console.error ('Error fetching loader data:', err);
		}
	}
	
	useEffect (() => {
		getAllFooterData ();
	}, []);
	
	const handleDownload = (file) => {
		const link = document.createElement ('a');
		link.href = file;
		link.download = file.split ('/').pop (); // Extract file name from path
		document.body.appendChild (link);
		link.click ();
		document.body.removeChild (link);
	};
	
	const handlePayAmount = (filePay) =>{
		const link = document.createElement ('a');
		link.href = filePay;
		link.download = filePay.split ('/').pop ();;
		document.body.appendChild (link);
		link.click ();
		document.body.removeChild (link);
	}
	
	return (
		<div className="mainFooterList">
			<div className="subFooterList">
				{
					FooterData.length === 0 ? (
						<p>No Data</p>
					) : (
						FooterData.map ((item, index) => (
							<div className="FooterList" key={index}>
								<div className="FooterListUIElements-image-box">
									<img src={item.VideoGif} alt=""/>
								</div>
								<div className="FooterListInfo">
									<div className="title">{item.title}</div>
									<p>{item.Developer}</p>
									<div className="mainDownloadBtn">
										{
											item.PayAmount === "Yes" ?(
												<>
													<button onClick={() => handlePayAmount(item.PayAmountUrl)}>Pay</button>
												</>
											): (
												<button className='DownloadBtn' onClick={() => handleDownload (item.ZipFile)}>Download</button>
											)
										}
									
									</div>
								</div>
							</div>
						))
					)
				}
			</div>
		</div>
	);
};

export default Footer;